import { getToken } from "../utils/utilFunctions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const headers = () => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${getToken()}`,
});

/**
 * Get all time logs for a task
 * @param {number|string} taskId
 */
export async function fetchTaskTimeLogs(taskId) {
    const res = await fetch(`${API_URL}/api/timeLog/${taskId}`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function fetchTimeLogs() {
    const res = await fetch(`${API_URL}/api/timeLog`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Create a new time log entry
 * @param {object} timeLogData
 */
export async function createTimeLog(timeLogData) {
    const res = await fetch(`${API_URL}/api/timeLog`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(timeLogData),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Delete a time log entry by ID
 * @param {number|string} id
 */
export async function deleteTimeLog(id) {
    const res = await fetch(`${API_URL}/api/timeLog/${id}`, {
        method: "DELETE",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return true;
}
